export default "__VITE_ASSET__BlhsEnD3__"